import React, { Component } from "react";
import { widget } from "../dockable";
import ReactCursorPosition from "react-cursor-position";
import Canvas from "../components/Canvas";
import css from "./Document.module.css";

class Document extends Component {
  static defaultProps = {
    closeable: true
  };
  render() {
    let size = {
      width: 1024,
      height: 1024
    };
    return (
      <div className={css.container}>
        <div
          style={{ width: size.width, height: size.height }}
          className={css.canvas}
        >
          <ReactCursorPosition>
            <Canvas
              width={size.width}
              height={size.height}
              onMouseDown={this.handleDrawBegin}
              onMouseMove={this.handleDraw}
              onMouseUp={this.handleDrawEnd}
            />
          </ReactCursorPosition>
        </div>
      </div>
    );
  }
}

export default widget(Document, {
  id: "Document",
  title: "Untitled Document"
});
